export const LOAD_MAINTENANCE_STATUS = "LOAD_MAINTENANCE_STATUS";
export const LOAD_MAINTENANCE_STATUS_FAIL = "LOAD_MAINTENANCE_STATUS_FAIL";
export const LOAD_MAINTENANCE_STATUS_OK = "LOAD_MAINTENANCE_STATUS_OK";
export const LOAD_MAINTENANCE_STATUS_START = "LOAD_MAINTENANCE_STATUS_START";
export const CLOSE_MAINTENANCE_WARNING = "CLOSE_MAINTENANCE_WARNING";
export const UPDATE_MAINTENANCE_STATUS = "UPDATE_MAINTENANCE_STATUS";
